import { createStateSelectorHook } from 'src/lib/sweetState';
import { DocumentStore } from '../../../store';

const useDocumentState = createStateSelectorHook(DocumentStore, [
  'activeVariationInstanceId',
  'detailsPanelVisibleForInstanceId',
]);

/**
 * We should have only one highlighted variation in the document editor view.
 * When deciding which variation should be highlighted, we use this priority:
 *   1) variation for which "details panel" is opened - top priority
 *   2) variation which is hovered by mouse cursor
 */
export const useActiveVariationInstanceId = () => {
  const { activeVariationInstanceId, detailsPanelVisibleForInstanceId } = useDocumentState();

  if (detailsPanelVisibleForInstanceId) {
    return detailsPanelVisibleForInstanceId;
  }
  return activeVariationInstanceId;
};
